
import search from "../partials/ais/client";
import {
	configure,
	searchBox
} from "instantsearch.js/es/widgets";

// custom connectors and widgets
import customMenuSelect from "../partials/ais/custom-menu-select";
import customInfiniteHits from "../partials/ais/custom-infinite-hits";

// helpers
import { translate } from "../partials/translate";
import { sortTable } from "../partials/ais/sort-fund-table";

// other
import { loading } from "../partials/ais/svgs";


/** Initiate the instant search instance
 * @returns {void}
 */

function initInstantSearch() {

	const aisSearchContainer = document.getElementById('ais-search-container');
	if (!aisSearchContainer || !search) {
		return;
	}

	search.addWidgets([
		configure({
			hitsPerPage: 200
		}),
		searchBox({
			container: "#searchbox",
			placeholder: translate('What are you looking for?')
		}),
		customInfiniteHits({
			container: document.querySelector('#hits')
		}),
		customMenuSelect({
			container: document.querySelector('#asset-class-menu'),
			attribute: 'primary.assetClass',
			defaultOption: translate('Asst. Class')
		}),
		customMenuSelect({
			container: document.querySelector('#investment-strategy-menu'),
			attribute: 'primary.investmentStrategy',
			defaultOption: translate('Invest. Strat.')
		}),
		customMenuSelect({
			container: document.querySelector('#region-menu'),
			attribute: 'primary.region',
			defaultOption: translate('Region')
		}),
		customMenuSelect({
			container: document.querySelector('#risk-rating-menu'),
			attribute: 'primary.riskRating',
			defaultOption: translate('Risk Level')
		}),
		customMenuSelect({
			container: document.querySelector('#base-currency-menu'),
			attribute: 'primary.baseCurrency',
			defaultOption: translate('Base Currency')
		}),
		customMenuSelect({
			container: document.querySelector('#hedging-menu'),
			attribute: 'purchaseOptions.hedged',
			defaultOption: translate('Hedging'),
			allText: "Show All Groups",
			transformItems(items) {
				return items.filter(item => item.value !== "false")
				.map(item => {
					return ({
						...item,
						label: 'Show Groups with Hedged Options',
					})
				});
			},
		})
	])

	// set up a loading state
	search.on('render', () => {
		const container = document.querySelector('#loading-indicator');
		if (search.status === 'stalled') {
			container.innerHTML = `${loading}`
		} else {
			container.innerHTML = '';
		}
	})

	const sortRow = document.getElementById('sort-row');
	// table headings
	const sortHeadings = Array.from(sortRow.querySelectorAll('th'));

	// helper function
	const removeAllActiveClasses = () => {
		sortHeadings.forEach((heading) => {
			heading.classList.remove('active');
		})
	}

	// set up events for table headings and sorting
	sortHeadings.forEach((heading, headingIndex) => {
		heading.addEventListener('click', (e) => {
			// get the table heading regardless of actual target
			const targetHeading = e.target.tagName === 'TH' ? e.target : e.target.parentElement;

			// is a sort already active?
			const alreadySorted = sortRow.querySelector('.active') && sortRow.querySelector('.active') !== targetHeading;

			// if already active, remove and reset the sort
			if (targetHeading.classList.contains('active')) {
				targetHeading.classList.remove('active');
				sortTable(headingIndex, targetHeading.dataset.sort, true);
				return;
			}

			// remove all active classes and add back to the target
			removeAllActiveClasses();
			targetHeading.classList.add('active');
			// sort it
			sortTable(headingIndex, targetHeading.dataset.sort, false, alreadySorted);
		})
	})


	// sort the table again on re-renders, this keeps any active sorts applied with new renders
	search.on('render', () => {
		let activeColumn = null;
		for (let i = 0; i < sortHeadings.length; i++) {
			if(sortHeadings[i].classList.contains('active')) {
				activeColumn = i;
				break;
			}
		}
		if (activeColumn != null) {
			sortTable(activeColumn, sortHeadings[activeColumn].dataset.sort);
		}
	})

	// and finally, start it up
	search.start();

	window.dispatchEvent(new Event("fundsLoaded"));

}


export default initInstantSearch();
